// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin: 0;
  padding: 0;
  cursor: move;
  margin-bottom: 4px !important;
}
:host .card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #dee2e6;
  transition: box-shadow 0.2s ease-in-out;
  margin-bottom: 4px;
  background-color: white;
  border: none;
  transition: all 0.2s ease-in-out;
}
:host .card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}
:host .card:hover .epic-delete-container .epic-badge {
  opacity: 0;
  visibility: hidden;
}
:host .card:hover .epic-delete-container .delete-btn {
  opacity: 1;
  visibility: visible;
}
:host .card-body {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
@media (max-width: 768px) {
  :host .card-body {
    padding: 0.5rem !important;
  }
}
:host .card-title {
  font-size: 0.9rem;
  font-weight: 300;
  margin: 0;
  color: #212529;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.3;
}
@media (max-width: 768px) {
  :host .card-title {
    font-size: 0.7rem !important;
    line-height: 1.3;
  }
}
@media (max-width: 576px) {
  :host .card-title {
    font-size: 0.65rem !important;
  }
}
:host .card-title[contenteditable=true] {
  cursor: text;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  min-height: 1.2em;
  line-height: 1.3;
}
:host .card-title[contenteditable=true]:focus {
  outline: 1px solid #888;
  background-color: #f8f9fa;
  white-space: pre-wrap;
}
:host .card-title[contenteditable=true]:before {
  content: attr(data-placeholder);
  color: #6c757d;
}
:host .card-title[contenteditable=true] * {
  display: inline !important;
  white-space: pre-wrap !important;
}
:host .text-muted {
  font-size: 0.75rem;
  white-space: nowrap;
  flex-shrink: 0;
}
:host .d-flex.justify-content-between.align-items-start {
  align-items: flex-start !important;
}
:host .d-flex.justify-content-between.align-items-start .card-title {
  flex-grow: 1;
  margin-right: 0.5rem;
  min-width: 0;
}
:host .epic-delete-container {
  position: relative;
  display: inline-block;
  min-height: 22px;
  min-width: 60px;
}
:host .epic-delete-container .epic-badge {
  opacity: 1;
  visibility: visible;
  transition: all 0.2s ease-in-out;
}
:host .epic-delete-container .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 22px;
  padding: 0;
  border-radius: 3px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 12px;
}
:host .epic-delete-container .delete-btn i {
  font-size: 10px;
}
:host .epic-delete-container .delete-btn:hover {
  transform: scale(1.1);
}
:host .priority-badge {
  font-size: 0.65rem !important;
  padding: 0.2rem 0.4rem !important;
}
@media (max-width: 768px) {
  :host .priority-badge {
    font-size: 0.65rem !important;
    padding: 0.2rem 0.4rem !important;
  }
}
@media (max-width: 768px) {
  :host {
    margin-bottom: 6px !important;
  }
  :host .card {
    min-height: 60px;
  }
}
@media (max-width: 576px) {
  :host .card {
    min-height: 50px;
  }
}

:host.creating-issue .card {
  border: 2px dashed #1a936f;
  background-color: rgba(26, 147, 111, 0.05);
}
:host.creating-issue .card .card-title {
  color: #1a936f;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/components/issue-card/issue-card.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;AACF;AACE;EACE,oDAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;AACJ;AACI;EACE,mDAAA;AACN;AAEQ;EACE,UAAA;EACA,kBAAA;AAAV;AAGQ;EACE,UAAA;EACA,mBAAA;AADV;AAOE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AALJ;AAOI;EANF;IAOI,0BAAA;EAJJ;AACF;AAOE;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AALJ;AAOI;EAXF;IAYI,4BAAA;IACA,gBAAA;EAJJ;AACF;AAMI;EAhBF;IAiBI,6BAAA;EAHJ;AACF;AAME;EACE,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,uBAAA;EACA,yBAAA;EACA,qBAAA;AAJN;AAOI;EACE,+BAAA;EACA,cAAA;AALN;AAQI;EACE,0BAAA;EACA,gCAAA;AANN;AAUE;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAWE;EACE,kCAAA;AATJ;AAWI;EACE,YAAA;EACA,oBAAA;EACA,YAAA;AATN;AAaE;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAXJ;AAaI;EACE,UAAA;EACA,mBAAA;EACA,gCAAA;AAXN;AAcI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAZN;AAcM;EACE,eAAA;AAZR;AAeM;EACE,qBAAA;AAbR;AAkBE;EACE,6BAAA;EACA,iCAAA;AAhBJ;AAkBI;EAJF;IAKI,6BAAA;IACA,iCAAA;EAfJ;AACF;AAmBE;EA9JF;IA+JI,6BAAA;EAhBF;EAkBE;IACE,gBAAA;EAhBJ;AACF;AAoBE;EACE;IACE,gBAAA;EAlBJ;AACF;;AAwBE;EACE,0BAAA;EACA,0CAAA;AArBJ;AAuBI;EACE,cAAA;EACA,kBAAA;AArBN","sourcesContent":[":host {\n  display: block;\n  margin: 0;\n  padding: 0;\n  cursor: move;\n  margin-bottom: 4px !important;\n\n  .card {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;\n    border: 1px solid #dee2e6;\n    transition: box-shadow 0.2s ease-in-out;\n    margin-bottom: 4px;\n    background-color: white;\n    border: none;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;\n\n      .epic-delete-container {\n        .epic-badge {\n          opacity: 0;\n          visibility: hidden;\n        }\n\n        .delete-btn {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n  }\n\n  .card-body {\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    @media (max-width: 768px) {\n      padding: 0.5rem !important;\n    }\n  }\n\n  .card-title {\n    font-size: 0.9rem;\n    font-weight: 300;\n    margin: 0;\n    color: #212529;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    word-break: break-word;\n    line-height: 1.3;\n\n    @media (max-width: 768px) {\n      font-size: 0.7rem !important;\n      line-height: 1.3;\n    }\n\n    @media (max-width: 576px) {\n      font-size: 0.65rem !important;\n    }\n  }\n\n  .card-title[contenteditable='true'] {\n    cursor: text;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    word-break: break-word;\n    min-height: 1.2em;\n    line-height: 1.3;\n\n    &:focus {\n      outline: 1px solid #888;\n      background-color: #f8f9fa;\n      white-space: pre-wrap;\n    }\n\n    &:before {\n      content: attr(data-placeholder);\n      color: #6c757d;\n    }\n\n    * {\n      display: inline !important;\n      white-space: pre-wrap !important;\n    }\n  }\n\n  .text-muted {\n    font-size: 0.75rem;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .d-flex.justify-content-between.align-items-start {\n    align-items: flex-start !important;\n\n    .card-title {\n      flex-grow: 1;\n      margin-right: 0.5rem;\n      min-width: 0;\n    }\n  }\n\n  .epic-delete-container {\n    position: relative;\n    display: inline-block;\n    min-height: 22px;\n    min-width: 60px;\n\n    .epic-badge {\n      opacity: 1;\n      visibility: visible;\n      transition: all 0.2s ease-in-out;\n    }\n\n    .delete-btn {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 24px;\n      height: 22px;\n      padding: 0;\n      border-radius: 3px;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.2s ease-in-out;\n      z-index: 10;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: none;\n      font-size: 12px;\n\n      i {\n        font-size: 10px;\n      }\n\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n  }\n\n  .priority-badge {\n    font-size: 0.65rem !important;\n    padding: 0.2rem 0.4rem !important;\n\n    @media (max-width: 768px) {\n      font-size: 0.65rem !important;\n      padding: 0.2rem 0.4rem !important;\n    }\n  }\n\n  // Touch-friendly on mobile\n  @media (max-width: 768px) {\n    margin-bottom: 6px !important;\n\n    .card {\n      min-height: 60px;\n    }\n  }\n\n  // Even smaller cards for tiny screens\n  @media (max-width: 576px) {\n    .card {\n      min-height: 50px;\n    }\n  }\n}\n\n// Host styles for creating issue state\n:host.creating-issue {\n  .card {\n    border: 2px dashed #1a936f;\n    background-color: rgba(26, 147, 111, 0.05);\n\n    .card-title {\n      color: #1a936f;\n      font-style: italic;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
